import { useSVGFilters } from 'apps/studio/lib/hooks/useSVGFilter'

export const GlassBackgroundEffect = ({
  className,
  children,
  as: Component = 'div',
  ...props
}) => {
  useSVGFilters(
    'glass',
    `
  <filter id="glass-filter" x="0%" y="0%" width="100%" height="100%" filterUnits="objectBoundingBox">
    <feImage x="0" y="0" result="edgeMask" xlink:href="data:image/svg+xml;utf8,
      <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%'>
        <radialGradient id='edge' cx='50%' cy='50%' r='75%'>
          <stop offset='0%' stop-color='black' stop-opacity='0'/>
          <stop offset='80%' stop-color='white' stop-opacity='1'/>
        </radialGradient>
        <rect width='100%' height='100%' fill='url(#edge)'/>
      </svg>" />
    <feComponentTransfer in="edgeMask" result="edgeMaskBoosted">
      <feFuncA type="identity"/>
    </feComponentTransfer>
    <feImage x="0" y="0" result="normalMap" xlink:href="data:image/svg+xml;utf8,
      <svg xmlns='http://www.w3.org/2000/svg' width='300' height='300'>
        <radialGradient id='invmap' cx='50%' cy='50%' r='75%'>
          <stop offset='0%' stop-color='rgb(14,81,196)'/>
          <stop offset='80%' stop-color='rgb(255,255,255)'/>
        </radialGradient>
        <rect width='100%' height='100%' fill='url(#invmap)'/>
      </svg>" />
    <feDisplacementMap in="SourceGraphic" in2="normalMap" scale="-252" xChannelSelector="A" yChannelSelector="A" result="displaced" />
    <feBlend in="displaced" in2="edgeMaskBoosted" mode="multiply" result="edgeDisplaced"/>
    <feMerge>
      <feMergeNode in="edgeDisplaced" in2="edgeMaskBoosted" />
    </feMerge>
  </filter>
`
  )

  return (
    <Component className={`glass-background-effect ${className}`} {...props}>
      <div className="glass-reflections"></div>
      <div className="glass-blur"></div>
      <div className="glass-tint"></div>
      <div className="glass-shine"></div>
      <div className="glass-text">{children}</div>
    </Component>
  )
}
